// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1hCV9","messages":"Chat_messages__1BGQj","dateDivider":"Chat_dateDivider__DXI7o"};